(function (window, angular, TweenLite) {
    'use strict';

    var module = angular.module("ngGreensockDraggable", []);

    /**
     * Defines the Component
     * For more informations, see https://greensock.com/docs/#/HTML5/GSAP/Utils/Draggable/
     */
    module.component('ngGreensockDraggable', {
        scope: {},
        bindings: {
            identifier: '@',
            type: '@',
            enable: '<?',
            edgeResistance: '=?',
            bounds: '<?',
            minimumMovement: '<?',
            zIndexBoost: '=?',
            throwProps: '=?',
            throw: '=?', // Custom throw effect (beta). To use it, make sure that throwProps is not set to true
            postLink: '&?',
            onPress: '&?',
            onDragStart: '&?',
            onDrag: '&?',
            onDragEnd: '&?',
            onRelease: '&?',
            onClick: '&?',
        },
        transclude: true,
        controller: ['$element', GreensockDraggableController],
        template: '<div class="ngDraggable" style="position: absolute;"><div ng-transclude></div></div>'
    });


    /**
     * Defines the Controller
     */
    function GreensockDraggableController($element) {

        /**
         * Component Root HTMLElement
         */
        this.$element = $element;

        /**
         * Draggable HTMLElement
         * @type {null}
         * @private
         */
        this._$draggableHTMLElement = null;

        /**
         * Draggable Object (applied to _$draggableHTMLElement)
         * @type {null}
         * @private
         */
        this._draggable = null;


        /**
         * Draggable Position on drag event
         * @type {{}}
         * @private
         */
        this._dragCoordinates = {};

    }

    GreensockDraggableController.prototype.$onInit = function () {

        if (this.identifier) {

            //set the draggable HTMLElement
            this._$draggableHTMLElement = angular.element(this.$element[0].getElementsByClassName('ngDraggable'));
            this._$draggableHTMLElement.addClass(this.identifier);


            var draggableCssSelector = '.ngDraggable.' + this.identifier.split(' ').join('.');

            //create the draggable object
            if ('Draggable' in window) {
                Draggable.create(draggableCssSelector, {
                    type: this.type,
                    enable: this.enable,
                    edgeResistance: this.edgeResistance,
                    bounds: this.bounds,
                    minimumMovement: this.minimumMovement,
                    throwProps: this.throwProps,
                    zIndexBoost: this.zIndexBoost,
                    onPress: this._onPress.bind(this),
                    onDragStart: this._onDragStart.bind(this),
                    onDrag: this._onDrag.bind(this),
                    onDragEnd: this._onDragEnd.bind(this),
                    onRelease: this._onRelease.bind(this),
                    onLockAxis: this._onLockAxis.bind(this),
                    onClick: this._onClick.bind(this),
                });

                this._draggable = Draggable.get(draggableCssSelector);
            }
        } else {
            console.error('An identifier has to be defined');
        }

    }

    GreensockDraggableController.prototype.$onChanges = function (changes) {

        //Update the draggable bounds
        if (this._draggable) {
            if (changes.hasOwnProperty('bounds')) {
                var currentBounds = changes.bounds.currentValue;
                if (currentBounds instanceof HTMLCollection) {
                    this._draggable.vars.bounds = currentBounds;
                } else {
                    this._draggable.vars.bounds = {};
                    this._draggable.vars.bounds = currentBounds;
                }
            }

            if (changes.hasOwnProperty('enable')) {
                if (changes.enable.currentValue) {
                    this._draggable.enable();
                } else {
                    this._draggable.disable();
                }
            }
        }
    }
    GreensockDraggableController.prototype.$postLink = function () {
        if (this.postLink) {
            this.postLink();
        }
    }

    GreensockDraggableController.prototype._onLockAxis = function (e) {

        if (this.onLockAxis) {
            this.onLockAxis();
        }
    };
    GreensockDraggableController.prototype._onClick = function (e) {

        if (this.onClick) {
            this.onClick({event: e});
        }
    };
    GreensockDraggableController.prototype._onPress = function (e) {

        if (this.onPress) {
            this.onPress({event: e});
        }
    };

    GreensockDraggableController.prototype._onDragStart = function (e) {

        this._dragCoordinates = [];
        this._dragCoordinates.push(this._getGestureCoordinates(e));

        if (this.onDragStart) {
            this.onDragStart({event: e});
        }
    };

    GreensockDraggableController.prototype._onDrag = function (e) {

        this._dragCoordinates.push(this._getGestureCoordinates(e));

        var firstCoordinates = this._dragCoordinates[0];
        var lastCoordinates = this._dragCoordinates[this._dragCoordinates.length - 1];

        var dX = lastCoordinates.x - firstCoordinates.x;
        var dY = lastCoordinates.y - firstCoordinates.y;

        if (this.onDrag) {
            this.onDrag({event: e, dX: dX, dY: dY});
        }
    };
    GreensockDraggableController.prototype._onRelease = function (e) {

        if (this.onRelease) {
            this.onRelease({event: e});
        }
    };
    GreensockDraggableController.prototype._onDragEnd = function (e) {

        if (this.throw && this.throwProps == false) {

            //get relevant coordinates to calculate the delta
            var relevantCoordinates = this._dragCoordinates[this._dragCoordinates.length - 1];
            if (this._dragCoordinates.length > 1) {
                relevantCoordinates = this._dragCoordinates[this._dragCoordinates.length - 2];
            }

            //computes the delta
            var dX = 0;
            var dY = 0;
            var coordinatesAtEnd = this._getGestureCoordinates(e);
            if (this.type === 'x' || this.type === 'x,y') {
                dX = coordinatesAtEnd.x - relevantCoordinates.x;
            }
            if (this.type === 'y' || this.type === 'x,y') {
                dY = coordinatesAtEnd.y - relevantCoordinates.y;
            }

            //animation
            TweenLite.to(this._$draggableHTMLElement, 1, {
                x: "+=" + (dX * 3),
                y: "+=" + (dY * 3),
                ease: Power4.easeOut,
                onUpdate: this._onThrownUpdate.bind(this)
            });
        }


        if (this.onDragEnd) {
            this.onDragEnd({event: e});
        }
    };

    GreensockDraggableController.prototype._onThrownUpdate = function () {

        //constraint maxX
        if (this._draggable.x > this._draggable.maxX) {
            TweenLite.set(this._$draggableHTMLElement, {x: this._draggable.maxX});

            //constraint minX
        } else if (this._draggable.x < this._draggable.minX) {
            TweenLite.set(this._$draggableHTMLElement, {x: this._draggable.minX});

            //constraint maxY
        } else if (this._draggable.y > this._draggable.maxY) {
            TweenLite.set(this._$draggableHTMLElement, {y: this._draggable.maxY});

            //constraint minY
        } else if (this._draggable.y < this._draggable.minY) {
            TweenLite.set(this._$draggableHTMLElement, {y: this._draggable.minY});
        }

        this._draggable.update();
    }

    /**
     * Returns the gesture coordinates {x,y} regarding the gesture event type (MouseEvent, TouchEvent)
     * @param gestureEvent
     * @returns {{x: number, y: number}}
     * @private
     */
    GreensockDraggableController.prototype._getGestureCoordinates = function (gestureEvent) {

        var coordinates = {x: 0, y: 0};
        if (gestureEvent instanceof TouchEvent) {

            if (gestureEvent.targetTouches && gestureEvent.targetTouches.length) {
                var touch = gestureEvent.targetTouches[0];
                coordinates.x = touch.pageX;
                coordinates.y = touch.pageY;
            } else if (gestureEvent.changedTouches && gestureEvent.changedTouches.length) {
                var touch = gestureEvent.changedTouches[0];
                coordinates.x = touch.pageX;
                coordinates.y = touch.pageY;
            }
        } else if (gestureEvent instanceof MouseEvent) {
            coordinates.x = gestureEvent.x;
            coordinates.y = gestureEvent.y;
        }

        return coordinates;
    };
})(window, window.angular, window.TweenLite);